export default "__VITE_ASSET__Bppv0KjQ__"